import React from 'react';
import ListItem from 'components/ListItem';
import { OperatorPersonId } from 'services/sprayEvents/types';

// @ts-ignore
import PersonFullName from 'components/PersonFullName';

export interface OwnProps {
    operatorPersonId: OperatorPersonId;
}

type Props = OwnProps;

export default class SummaryApplicationApplicatorListItem extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { operatorPersonId } = this.props;

        return (
            <ListItem
                description="Applicator"
                value={<PersonFullName personId={operatorPersonId} />}
            />
        );
    }
}
